{
  "00945c89f76b547f": "Calificación",
  "0b3d8801e8101ab3": "Bloque de orientación creado",
  "14303aa0c4a08d39": "Fecha de finalización",
  "19766ed6ccb2f4a3": "Cancelar",
  "4759498ac2a719c6": "Crear",
  "59568730f215c863": "Error al crear el bloque de orientación",
  "5b4dee0fb8e18745": "Bloque de orientación",
  "80625961671ca1f3": "Crear bloque de orientación",
  "8169693101a4536c": "Fecha de inicio",
  "a7cba5fc45cdd4cf": "Notas para profesionales (opcional)",
  "ae65d096550ff4eb": "Capacidad",
  "ea790973625add62": "Los bloques de orientación no se publican en el mercado. Las asignaciones se gestionan internamente."
}
